export default "__VITE_ASSET__2cb48423__"